import React from 'react'
import styled from 'styled-components'

import Divider from './Divider'

const Wrapper = styled.div`
  background: ${(props) => props.theme.colors.careers_midblue};
  height: 60px;
  position: sticky;
  top: -1px;
  z-index: 1000;
  padding: 0 20px;
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 1;
  overflow: hidden;
  border-bottom: 1px solid white;

  @media (min-width: 960px) {
    display: block;
  }

  @media (min-width: 1360px) {
    padding: 0 60px;
  }

  a {
    color: ${(props) => props.theme.colors.white};
    text-decoration: none;
    position: relative;
    display: inline-flex;
    height: 100%;
    align-items: center;
    text-align: center;
    display: none;

    @media (min-width: 960px) {
      display: inline-flex;
    }
  }

  a:last-child {
    display: inline-flex;
  }

  a:hover,
  a:focus {
    font-weight: bold;
    text-decoration: underline;
    color: ${(props) => props.theme.colors.white} !important;
  }
`

const Inner = styled.div`
  max-width: 1360px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: 960px) {
    justify-content: space-between;
  }
`

const StickyTape = () => (
  <Wrapper>
    <Inner>
      <a href="https://careers.citygate.co.uk/jobs">Current Opportunities</a>
      <Divider />
      <a href="https://careers.citygate.co.uk/jobs/vacancy/find/results/action/posbrowser_resetto/?filter_poscodelist2=1">
        Sales
      </a>
      <Divider />
      <a href="https://careers.citygate.co.uk/jobs/vacancy/find/results/action/posbrowser_resetto/?filter_poscodelist2=8">
        Aftersales
      </a>
      <Divider />
      <a href="https://careers.citygate.co.uk/jobs/vacancy/find/results/action/posbrowser_resetto/?filter_poscodelist2=8">
        Technicians
      </a>
      <Divider />
      <a href="https://careers.citygate.co.uk/jobs">See All Opportunities</a>
    </Inner>
  </Wrapper>
)

export default StickyTape
